import { ReactElement, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

import styles from "./index.module.css";
import { useOrientation } from "../../lib/dom";
import { useSettings } from "../../state/settings";
import { useDrawings } from "../../state/drawings";
import { useTool } from "../../state/tool";
import Tooltip from "../shared/Tooltip";
import Header from "./Header";
import Sensor from "./Sensor";
import AxisLabel from "./AxisLabel";
import Palette from "./Palette";
import Thumbnails from "./Thumbnails";

export default function Edit(): ReactElement {
  const isLayoutHorizontal = useOrientation();
  const { settings } = useSettings();

  const { getDrawing } = useDrawings();
  const drawing = getDrawing(useParams().id ?? "");

  const { setTool } = useTool();
  useEffect(() => setTool("brush"), [setTool]);

  return drawing === undefined ? (
    <Navigate to={"/"} replace={true} />
  ) : (
    <>
      <Tooltip />

      <div className={styles.wrapper}>
        <Header drawing={drawing} />

        <div
          className={`${styles.layout} ${
            settings.axisLabels ? styles.showAxisLabels : ""
          } ${isLayoutHorizontal ? styles.horizontal : styles.vertical} ${
            settings.leftHanded ? styles.leftHanded : styles.rightHanded
          }`}
        >
          <section className={styles.editArea}>
            {settings.axisLabels ? <AxisLabel axis={"y"} /> : undefined}

            <Sensor drawing={drawing} />

            {settings.axisLabels ? (
              <div className={styles.xAxis}>
                <AxisLabel axis={"x"} />
              </div>
            ) : undefined}
          </section>

          <section className={styles.palette}>
            <Palette drawing={drawing} horizontal={isLayoutHorizontal} />
          </section>

          <section className={styles.thumbnails}>
            <Thumbnails
              preview={drawing.preview}
              horizontal={isLayoutHorizontal}
            />
          </section>
        </div>
      </div>
    </>
  );
}
